import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { OSSIARCH_BONEREAPERS } from 'meta/factions'
import { BATTLESHOCK_PHASE, CHARGE_PHASE, COMBAT_PHASE, DURING_GAME, HERO_PHASE, MOVEMENT_PHASE, SHOOTING_PHASE, START_OF_ROUND, WARDS_PHASE } from 'types/phases'

const BattleTraits = {
  [OSSIARCH_BONEREAPERS]: {
    effects: [
      {
        name: `Immortal Elite - Once Per Battle Round`,
        desc: `Declare: You must use this ability if there are any friendly Ossiarch Bonereapers Heroes on the battlefield. Pick a friendly Ossiarch Bonereapers Hero to be the target.
        Effect: You gain a number of relentless discipline points equal to the number after the target's Relentless Discipline keyword. At the end of the battle round, any unspent relentless discipline points are lost.`,
        when: [START_OF_ROUND],
      },
      {
        name: `Remorseless March`,
        desc: `Declare: Pick a friendly Ossiarch Bonereapers unit that has not used a Relentless Discipline ability this phase to use this ability.
        Effect: Spend 1 relentless discipline point. If that unit is reinforced and has more than half of its starting models, spend 2 relentless discipline points instead. Add 3" to the Move characteristic of that unit for the rest of the phase. That unit cannot use Run abilities for the rest of the turn.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Impassive Retreat`,
        desc: `Declare: Pick a friendly Ossiarch Bonereapers unit that has not used a Relentless Discipline ability this phase to use this ability.
        Effect: Spend 1 relentless discipline point. If that unit is reinforced and has more than half of its starting models, spend 2 relentless discipline points instead. For the rest of the turn, that unit can use Charge abilities even if they used a Retreat ability in the same turn.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Ruthless Extermination - Once Per Turn - Reaction: You declared a Shoot ability for a unit that has not used a Relentless Discipline ability this phase`,
        desc: `Used By: The unit using the Shoot ability.
        Effect: Spend 1 relentless discipline point. If that unit is reinforced and has more than half of its starting models, spend 2 relentless discipline points instead. Subtract 1 from ward rolls for damage points inflicted by attacks made as part of that Shoot ability.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Pitiless Assault - Reaction: You declared a Fight ability for a unit that has not used a Relentless Discipline ability this phase`,
        desc: `Used By: The unit using the Fight ability.
        Effect: Spend 1 relentless discipline point. If that unit is reinforced and has more than half of its starting models, spend 2 relentless discipline points instead. Add 1 to wound rolls for attacks made as part of that Fight ability.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Inviolate Legions - Reaction: Opponent declared an Attack ability`,
        desc: `Used By: A friendly Ossiarch Bonereapers unit targeted by that Attack ability. Friendly Ossiarch Bonereapers units can use this ability more than once per phase.
        Effect: Spend 1 relentless discipline point. If that unit is reinforced and has more than half of its starting models, spend 2 relentless discipline points instead. That unit has Ward (5+) against damage points inflicted by attacks made as part of that Attack ability.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
      {
        name: `Bone-Tithe Nexus (Faction Terrain) - Deadly Aura`,
        desc: `Effect: Enemy units cannot be set up within X" of this terrain feature, where X is determined by the current battle round, as follows:
        Round / X
        1-9"
        2-12"
        3-15"
        4-18"
        5-21"`,
        when: [HERO_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(BattleTraits, 'battle_trait')
